import { getFirebaseAuth } from '@/shared/firebase/firebase';

export const getCurrentUserUid = () => getFirebaseAuth().currentUser.uid;
